import React from 'react';
import { Bookmark, Clock, MapPin, Calendar as CalendarIcon, Star, Settings } from 'lucide-react';

const DayView = () => {
    return (
        <div className="day-view-content">
            <div className="view-header">
                <h2 className="view-title">Tomorrow <span>| January 02</span></h2>
                <div className="view-actions">
                    <button className="action-btn"><Star size={16} /> Favorite</button>
                    <button className="action-btn"><Settings size={16} /> Setting</button>
                </div>
            </div>

            {/* Main Featured Event */}
            <div className="main-event-card">
                <img 
                    src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&q=80" 
                    alt="Design Thinking Essentials" 
                    className="event-image"
                />
                <div className="event-details">
                    <div className="event-header">
                        <span className="category-tag">Workshop</span>
                        <button className="bookmark-btn">
                            <Bookmark size={20} />
                        </button>
                    </div>
                    <h2 className="event-title">Design Thinking Essentials</h2>
                    <p className="event-desc">
                        Empower you to tackle complex challenges through a human-centered approach, starting with empathizing with users, defining problems, and ideating creative solutions.
                    </p>
                    <div className="event-meta">
                        <div className="meta-item">
                            <CalendarIcon size={18} />
                            <span>Sat, Jan 06</span>
                        </div>
                        <div className="meta-item">
                            <Clock size={18} />
                            <span>10:00 am</span>
                        </div>
                    </div>
                    <div className="meta-item" style={{marginTop: '1rem'}}>
                        <MapPin size={18} />
                        <span>Pole, doe Marten.</span>
                    </div>
                </div>
            </div>

            {/* Secondary Event */}
            <div className="secondary-event-card">
                <img 
                    src="https://images.unsplash.com/photo-1593508512255-86ab42a8e620?w=300&q=80" 
                    alt="Future of AI 2026" 
                    className="secondary-image"
                />
                <div className="secondary-details">
                    <span className="category-tag">Workshop</span>
                    <h3>Future of AI 2026</h3>
                    <p>Empower you to tackle complex challenges through a human-centered approach, starting with empathizing with users, defining problems, and ideating creative solutions.</p>
                </div>
                <div className="secondary-meta">
                    <div className="meta-item">
                        <span>Mon, Jan 08</span>
                        <CalendarIcon size={16} />
                    </div>
                    <div className="meta-item">
                        <span>10:00 am</span>
                        <Clock size={16} />
                    </div>
                    <div className="meta-item">
                        <span>Pole, doe Marten.</span>
                        <MapPin size={16} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DayView;
